import { Company, Position } from '@staffedupusa/shared-components';

export const mockPosition = (overrides?: Partial<Position>) => ({
  commission: false,
  company: {} as Company,
  id: 2,
  num_open: 1,
  s_description: 'description',
  s_salary: 100,
  s_salary_max: 200,
  s_slug: 'slug',
  s_title: 'title',
  s_type: 'type',
  standard_position: {
    count_assigned: 1,
    description: 'description',
    id: 1,
    name: 'name',
  },
  status: 2,
  tips: false,
  ...overrides,
});

export const POSITION_MOCK = mockPosition();
